import { RELEASE_NOTES_CDN_URL, releaseNotesBucket } from 'src/config';
import { FlashbarItem } from 'src/components/WhatsNew/FeatureType';
import { FlashbarTemplate } from 'src/components/WhatsNew/FlashbarForm/FlashbarFormTemplates';
import { deleteFlashbarItemFromS3 } from 'src/utils/S3Upload';
import { logger } from 'src/utils/logger';

export const fetchFlashbarItems = async (): Promise<FlashbarItem[]> => {
	try {
		const response = await fetch(`${RELEASE_NOTES_CDN_URL}/releases/flashbar-items.json?t=${Date.now()}`);
		if (!response.ok) {
			return [];
		}

		const items: FlashbarItem[] = await response.json();

		const now = new Date().toISOString();
		const activeItems = (items || []).filter(
			(item) => !item.expiresAt || item.expiresAt > now
		);

		if (activeItems.length < (items || []).length) {
			deleteExpiredItemsFromS3(activeItems).catch((err: unknown) =>
				logger.error(`Failed to prune expired flashbar items from S3 [ error ] ::: [ ${JSON.stringify(err)} ]`)
			);
		}

		return activeItems;
	} catch (error) {
		logger.error(`Failed to fetch flashbar items [ error ] ::: [ ${JSON.stringify(error)} ]`);
		return [];
	}
};

export const deleteFlashbarItem = async (itemId: string): Promise<void> => {
	await deleteFlashbarItemFromS3(itemId, releaseNotesBucket);
};

export const fetchFlashbarTemplates = async (): Promise<FlashbarTemplate[]> => {
	try {
		const response = await fetch(`${RELEASE_NOTES_CDN_URL}/releases/flashbar-templates.json?t=${Date.now()}`);
		if (!response.ok) {
			return [];
		}

		return (await response.json()) as FlashbarTemplate[];
	} catch (error) {
		logger.error(`Failed to fetch flashbar templates [ error ] ::: [ ${JSON.stringify(error)} ]`);
		return [];
	}
};


const deleteExpiredItemsFromS3 = async (activeItems: FlashbarItem[]): Promise<void> => {
	const { uploadCleanedFlashbarItems } = await import('src/utils/S3Upload');
	await uploadCleanedFlashbarItems(activeItems, releaseNotesBucket);
};
